export const SM = 320;
export const MD = 672;
export const LG = 1312;
